import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Item = styled(Link)`
  text-decoration: none;
  text-transform: uppercase;
  color: ${props => props.theme.colorPrimary};
  font-size: 17px;
  font-weight: 600;
  padding: 1rem 0;

  &:hover,
  &:focus {
    color: ${props => props.theme.colorGrayDark};
  }

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;
const NavigationItem = props => {
  return (
    <Item
      to={{ pathname: props.link }}
      className={props.className}
      onClick={props.closeSideDrawer}
    >
      {props.children}
    </Item>
  );
};

export default NavigationItem;



// WEBPACK FOOTER //
// ./src/components/Navgation/NavigationItems/NavigationItem/NavigationItem.js